import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { useSignal } from '@preact/signals-react';
import { useEffect } from 'react';

import { authError } from '../state/auth';

export function SessionStatus() {
    const error = useSignal(authError.value);

    useEffect(() => {
        const unsubscribe = authError.subscribe((value) => {
            error.value = value;
        });
        return unsubscribe;
    }, []);

    if (!error.value) return null;

    const isSessionExpired = error.value.toLowerCase().includes('expired');
    const isNetworkError = error.value.toLowerCase().includes('network') || 
                          error.value.toLowerCase().includes('connection');

    return (
        <div className={`fixed top-4 right-4 z-50 max-w-sm p-4 rounded-lg shadow-lg ${
            isSessionExpired ? 'bg-red-100 border border-red-400' : 
            isNetworkError ? 'bg-yellow-100 border border-yellow-400' : 
            'bg-orange-100 border border-orange-400'
        }`}>
            <div className="flex items-start">
                <ExclamationTriangleIcon className={`w-5 h-5 mr-2 flex-shrink-0 ${
                    isSessionExpired ? 'text-red-600' : 
                    isNetworkError ? 'text-yellow-600' : 
                    'text-orange-600'
                }`} />
                <div>
                    <p className={`text-sm font-medium ${
                        isSessionExpired ? 'text-red-800' : 
                        isNetworkError ? 'text-yellow-800' : 
                        'text-orange-800'
                    }`}>
                        {error.value}
                    </p>
                    {isNetworkError && (
                        <p className="mt-1 text-xs text-yellow-700">
                            We'll keep trying to reconnect automatically.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}